import axios from 'axios'
import { useUserStore } from '@/store'
const CryptoJS = require('crypto-js')
// import router from '@/router';  // 根据你的项目结构和文件路径进行调整

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_LOGIN_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {

    const param = config.data;
    let userStore = useUserStore();
    userStore.$patch({
      requestCode: 0
    })
    if (config.access !== false) {
      if (userStore.access) {
        param['userId'] = userStore.access.userId;
        param['accessToken'] = userStore.access.accessToken;
      }
    }

    const body = {
        osType: 'web',
        "ctime": Date.now(),
        isEnc: 0,
        appName: "jianpin_web_editor",
        deviceMark: "abcd1234",
        version: "1.0.0",
        param: param
    }
    
    let encryptStr = '';
    //生成key升序数组
    let arr = Object.keys(body);
    arr.sort();
    for (let i in arr) {
        let _value = '';
        if (Array.isArray(body[arr[i]])) {
        _value = JSON.stringify(body[arr[i]])
        } else {
        _value = config.data[arr[i]];
        }
        encryptStr += arr[i] + '=' + _value + '&';
    }

    encryptStr = encryptStr.substr(0, encryptStr.length - 1);
    encryptStr = encodeURIComponent(encryptStr);
    let hash_result = CryptoJS.HmacSHA256(encryptStr, "jc3mSBvkAdxV9KKVAw5G8dW38nFCGj");
    let base64 = CryptoJS.enc.Base64.stringify(hash_result);
    base64 = encodeURIComponent(base64);
    body['sign'] = base64;

    config.data = body;

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response
    // const currentRoute = router.currentRoute;
    if(res.data.code == 217){
      console.log('217报错')
      let userStore = useUserStore();
      userStore.$patch({
        requestCode: 217
      })
      return res;
    }
    return res
  },
  error => {
    console.log(error)

    return Promise.reject(error)
  }
)

export default service
